import React from "react";
import Card from "../ui/Card";
import TapIcon from "../../../services/TapIcon";
import DateService from "../../../services/DateService";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";

const Documents = ({
  title,
  documents,
  loading,
  emptyMessage = "No records found",
}) => {
  if (loading) {
    return (
      <Card title={title}>
        <div className="text-center py-4">
          <Loader />
        </div>
      </Card>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <Card title={title}>
        <div className="text-center py-4 text-muted">
          {emptyMessage}
        </div>
      </Card>
    );
  }

  return (
    <Card title={title}>
      {documents.map((item, index) => (
        <div
          key={item.path || index}
          className="border my-2 my-sm-3"
          style={{
            border: "1px solid #e0e0e0",
            background: "#fff",
            overflow: "hidden"
          }}
        >
          <div
            style={{
              padding: "8px 12px",
              borderBottom: "1px solid #e0e0e0",
              fontWeight: 600,
              fontSize: "clamp(13px, 1.2vw, 15px)",
              background: "#f8f9fa"
            }}
          >
            {item.name || "Document"}
          </div>
          <div style={{ padding: "10px 12px" }}>
            <div className="d-flex flex-column flex-sm-row flex-wrap justify-content-between align-items-sm-center" style={{ gap: "8px", marginBottom: "10px" }}>
              <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: "4px" }}>
                <span style={{
                  fontWeight: 500,
                  fontSize: "clamp(11px, 0.9vw, 13px)",
                  color: "#6c757d",
                  whiteSpace: "nowrap"
                }}>
                  Due Date:
                </span>
                <span style={{
                  marginLeft: "2px",
                  fontWeight: 500,
                  fontSize: "clamp(11px, 0.9vw, 13px)",
                  wordBreak: "break-word"
                }}>
                  {item?.feed_date_time
                    ? DateService.dateTimeFormat(item.feed_date_time, "DD-MMM-YYYY")
                    : "-"}
                </span>
              </div>

            </div>


            <div className="mt-2">
              <div style={{
                fontWeight: 500,
                fontSize: "clamp(12px, 1vw, 14px)",
                marginBottom: "6px",
                color: "#495057"
              }}>
                Documents:
              </div>
              <div className="row">
                <div className="col-sm-6 mb-2">
                  <div
                    className="d-flex justify-content-between align-items-center h-100"
                    style={{
                      padding: "8px 10px",
                      background: "#f8f9fa",
                      gap: "8px"
                    }}
                  >
                    <span
                      style={{
                        fontSize: "13px",
                        wordBreak: "break-word",
                        flex: 1
                      }}
                    >
                      {item.name && item.number ? `${item.name} (${item.number})` : item.name || "-"}
                    </span>

                    <span
                      className="text-primary"
                      onClick={() => window.open(item.path, "_blank")}
                      style={{
                        cursor: "pointer",
                        color: "#3CB5A0",
                        flexShrink: 0
                      }}
                    >
                      <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
      }
    </Card >
  );
};

export default Documents;